import { format } from 'date-fns/format';
import 'knockout.validation';
import ko from 'knockout';
import { LocaleUtils } from './locale-utils';
import { R } from './Resources.resx';

export class DateTimeViewModel {
	public date = ko.observable<Date>(new Date());
	public time = ko.observable<Date>(new Date());

	public dateTime = ko.pureComputed(() => {
		const date = this.date();
		const time = this.time();
		if (date == null || time == null) {
			return null;
		}
		date.setHours(time.getHours(), time.getMinutes(), 0, 0);
		return date;
	});

	public setCurrentDateAndTime = (): void => {
		this.date(new Date());
		this.time(new Date());
	};

	public formatted = ko.pureComputed(() => {
		const d = this.dateTime();
		if (d == null) {
			return null;
		}
		return format(d, LocaleUtils.getDateTimeFormat());
	});

	constructor() {
		const required = {
			message: R.ErrorFieldIsMandatory,
			param: true,
		};
		this.date.extend({ required: required });
		this.time.extend({ required: required });
	}
}
